import React from 'react';
import styles from '../Form.module.scss';

type FormInputPropsType = {
  children: React.ReactNode;
  className?: string;
  for?: string;
};

const FormInput = (props: FormInputPropsType) => {
  return (
    <div className={styles.formInput}>
      {props.children}
    </div>
  );
};

export default FormInput;
